import * as React from "react";
import { render } from "react-dom";
import App from "./app";

function createEmbed(domQuery: string, options = {}) {
  const elem = document.querySelector(domQuery);

  if (!elem) {
    // eslint-disable-next-line no-console
    console.error("Invalid document selector", domQuery);
    return;
  }

  render(<App {...options} />, elem);
}

// @ts-ignore
window.createEmbed = createEmbed;
